import { useMemo, useState } from "react";

import "./user-avatar.css";
import api from "../../../api/api";
import HintModal from "../common/hint-modal";
import filterUsersByName from "../common/filter-users-by-name";

import useGetUserAvatar from "./hooks/useGetUserAvatar";
import ImagePreviewModal from "./modals/image-preview-modal";

const UserAvatar = ({ searchTerm = "" }) => {
  // const heading = "Give each user an avatar to recognize them in the program";
  const points = [
    "Upload a new photo to be used as an avatar for each firm user in all the possible sizes throughout the program. The photo uploaded should be a square and will center and rescale the image to the correct resolution and size.",
  ];
  const { data, _loading, _error, refetch } = useGetUserAvatar();
  const filteredUsers = useMemo(() => filterUsersByName(data, searchTerm), [data, searchTerm]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const handleFileChange = (e, userId, _fn) => {
    const file = e.target.files[0];

    if (file) {
      setSelectedFile(file);
      setPreviewImage(URL.createObjectURL(file));
      setSelectedUserId(userId);
      setIsModalOpen(true);
    }
  };

  const handleSaveAvatar = async () => {
    if (selectedFile && selectedUserId) {
      const formData = new FormData();
      formData.append("user_id", selectedUserId);
      formData.append("file", selectedFile);

      try {
        const _response = await api.post("/api/firmsetting-page/upload-user-avatar/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        refetch();
        setIsModalOpen(false);
      } catch (error) {
        console.error("Error uploading avatar:", error);
      }
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setPreviewImage(null);
    setSelectedUserId(null);
    setIsModalOpen(false);
  };
  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      {/* <div
        className="d-flex justify-content-end m-b-5"
        onClick={() => {
          handleHintToggle();
        }}
      >
        <i className="ic ic-19 ic-help-2 cursor-pointer" />
      </div> */}
      <div className="tab-content">
        <table
          className={
            "table table-borderless table-striped table-treatment has-specialty-icon has-height-25 block-table"
          }
          id="treatment-summary-table"
        >
          <thead>
            <tr id="tb-header">
              <th />
              <th className="text-uppercase text-center">Firm User</th>
              <th className="text-uppercase text-center">User Name</th>
              <th className="text-uppercase" />
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 &&
              filteredUsers.map((userAvatars, idx) => (
                <tr key={userAvatars.user.id} style={{ height: "70px" }}>
                  <td
                    key={userAvatars?.user.id}
                    className="text-center m-r-5 m-l-5 td-autosize"
                    style={{ color: "gray" }}
                  >
                    {idx + 1}
                  </td>
                  <td className="text-center" style={{ width: "20%" }}>
                    <button className="mb-1 btn user-profile-class give-white-space d-flex justify-content-between align-items-center">
                      <>
                        {userAvatars?.profile_pic_63p ? (
                          <img
                            src={userAvatars?.profile_pic_63p}
                            className="client-image ic-63 position-relative"
                            alt=""
                            style={{
                              minWidth: "63px",
                              border: "1px solid var(--primary-50)",
                            }}
                          />
                        ) : (
                          <span
                            className="ic ic-avatar ic-63 has-avatar-icon has-cover-img position-relative"
                            style={{
                              marginRight: "5px",
                              minWidth: "63px",
                              border: "1px solid var(--primary-50)",
                            }}
                          />
                        )}
                      </>
                      <>
                        {userAvatars?.profile_pic_29p ? (
                          <img
                            src={userAvatars?.profile_pic_29p}
                            className="ic-29 position-relative"
                            alt=""
                            style={{
                              border: "1px solid var(--primary-50)",
                              borderRadius: "50%",
                              marginRight: "8px",
                            }}
                          />
                        ) : (
                          <span
                            className="ic ic-avatar ic-29 has-avatar-icon has-cover-img position-relative"
                            style={{
                              marginRight: "8px",
                              border: "1px solid var(--primary-50)",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                      </>
                      <>
                        {userAvatars?.profile_pic_19p ? (
                          <img
                            src={userAvatars?.profile_pic_19p}
                            className="ic-19 position-relative"
                            alt=""
                            style={{
                              border: "1px solid var(--primary-50)",
                              borderRadius: "50%",
                              marginRight: "8px",
                            }}
                          />
                        ) : (
                          <span
                            className="ic ic-avatar ic-19 has-avatar-icon has-cover-img position-relative"
                            style={{
                              marginRight: "8px",
                              border: "1px solid var(--primary-50)",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                        <span className="m-l-2">
                          {userAvatars?.user?.first_name} {userAvatars?.user?.last_name}
                        </span>
                      </>
                    </button>
                  </td>
                  <td className="td-autosize text-center">{userAvatars?.user?.username}</td>
                  <td className="text-end">
                    <button className="custom-button-container">
                      <label
                        htmlFor={`custom-upload-button-${userAvatars?.user?.id}`}
                        className="user-upload-class"
                        style={{ cursor: "pointer" }}
                      >
                        Upload New Firm User Avatar
                      </label>
                      <input
                        type="file"
                        id={`custom-upload-button-${userAvatars?.user?.id}`}
                        className="custom-file-input"
                        style={{ display: "none" }}
                        onChange={(e) => handleFileChange(e, userAvatars?.id)}
                      />
                    </button>

                    <button className="custom-button-container d-none">
                      <label for="custom-delete-button-8" className="custom-delete-button-8">
                        Remove
                      </label>
                      <input type="hidden" className="staffID" value="8" />
                      <input
                        type="file"
                        id="custom-delete-button-8"
                        className="custom-file-input"
                      />
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <ImagePreviewModal
          show={isModalOpen}
          handleClose={handleCancel}
          handleSave={handleSaveAvatar}
          previewImage={previewImage}
        />
      )}

      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </div>
  );
};

export default UserAvatar;
